import {
  VALIDATE_UTILITY_ATTACHMENTS,
  VALIDATE_UTILITY_ATTACHMENTS_SUCCESS,
  VALIDATE_UTILITY_ATTACHMENTS_ERROR,
  VALIDATE_UTILITY_ATTACHMENTS_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const ValidateUtilityAttachments = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_UTILITY_ATTACHMENTS:
      return { ...state, loading: true, data: null, error: null };
    case VALIDATE_UTILITY_ATTACHMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case VALIDATE_UTILITY_ATTACHMENTS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case VALIDATE_UTILITY_ATTACHMENTS_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default ValidateUtilityAttachments;
